<template>
    <div>

        <button class="button is-outlined is-info table-button upload_btn" @click="openModal"><i class="zmdi zmdi-file-add"></i> {{ buttonLabel }}</button>
        <Modal :confirmLabel="$t('components.shared.filesUpload.fileUploaderValidateButton')"
            :cancelLabel="false"
            :modalTitle="$t('components.shared.filesUpload.editEvalTitleModal')"
            :isOpen="isOpen"
            @onConfirm="onConfirm"
            @onClose="onClose">

            <FilesUploader @fileUploaded="handleUploadedFile" v-if="isOpen" />

        </Modal>
    </div>
</template>

<script>
import FilesUploader from '@/components/shared/filesUploader/filesUploader'

export default {
    name: 'AddDocsModal',
    props: [],
    components: {
        FilesUploader
    },
    beforeCreate() {

    },
    data(){
        return {
            isOpen: false,
            fileList: []
        }
    },
    computed: {
        buttonLabel(){
            return this.$t('components.shared.filesUpload.editEvalTitleModal')
        }
    },
    methods: {
        handleUploadedFile(fileList){
            this.fileList = fileList
        },
        openModal(){
            this.isOpen = true
        },
        onConfirm(){
            this.sendFileListEvent()
        },
        onClose(){
            this.sendFileListEvent()
        },
        sendFileListEvent(){
            this.isOpen = false
            this.$emit("filesUploaded", this.fileList)
        }
    }
}
</script>

<style lang="scss" scoped>
.upload_btn{
    i{
        font-size: 1.5rem;
        color: $info;
        margin-right: 8px;
    }
    &:hover i{
        color: white;
    }

}
</style>